interface HelperTextComponentProps {
  text: string;
  error?: string;
}

export function HelperTextComponent(props: Readonly<HelperTextComponentProps>) {
  const { text, error } = props;

  if (error) return null;
  if (!text || text.length === 0) return null;

  return <p className="text-sm text-muted-foreground">{text}</p>;
}
